/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 事故状況
 */
export type TrafficAccidentSituationEnum =
  (typeof TrafficAccidentSituationEnum)[keyof typeof TrafficAccidentSituationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrafficAccidentSituationEnum = {
  VEHICLE: 'VEHICLE',
  MOTORCYCLE: 'MOTORCYCLE',
  BICYCLE: 'BICYCLE',
  PEDESTRIAN: 'PEDESTRIAN',
} as const;
